module.exports = __webpack_public_path__ + "amazonlinux-bf045e2ffc457229b83de1f35c21f89d.svg";